import React from "react";


export default function AdvanceCTABanner({text, ctaURL, ctaString, imageSource, imageDirection, secondaryCTAString, secondaryCTAURL}) {

    // imageDirection => "left" or "right"
    return (
        <div
            className="elementor-element elementor-element-89e89f8 e-flex e-con-boxed e-con e-parent elementor-kit-159 elementor elementor-1652"
            data-id="89e89f8"
            data-element_type="container"
        >
            <div className="e-con-inner">
                <div
                    className="elementor-element elementor-element-402082c elementor-widget elementor-widget-template"
                    data-id="402082c"
                    data-element_type="widget"
                    data-widget_type="template.default"
                >
                    <div className="elementor-widget-container">
                        <div className="elementor-template">
                            <div
                                data-elementor-type="container"
                                data-elementor-id={1566}
                                className="elementor elementor-1566"
                                data-elementor-post-type="elementor_library"
                            >
                                <div
                                    className="elementor-element elementor-element-633576a6 e-flex e-con-boxed e-con e-parent"
                                    data-id="633576a6"
                                    data-element_type="container"
                                >
                                    <div className="e-con-inner">
                                        <div
                                            className="elementor-element elementor-element-2a4fb96c e-flex e-con-boxed e-con e-child"
                                            data-id="2a4fb96c"
                                            data-element_type="container"
                                            data-settings='{"background_background":"classic"}'
                                        >
                                            <div className="e-con-inner">
                                                <div
                                                    className="elementor-element elementor-element-672681a4 e-con-full e-flex e-con e-child"
                                                    data-id="672681a4"
                                                    data-element_type="container"
                                                >
                                                    <div
                                                        className="elementor-element elementor-element-79038120 elementor-widget elementor-widget-heading"
                                                        data-id={79038120}
                                                        data-element_type="widget"
                                                        data-widget_type="heading.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <h2 className="elementor-heading-title elementor-size-default">
                                                                {text}
                                                            </h2>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="elementor-element elementor-element-30942c0e elementor-align-left elementor-widget elementor-widget-button"
                                                        data-id="30942c0e"
                                                        data-element_type="widget"
                                                        data-widget_type="button.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <div className="elementor-button-wrapper text-center md:text-left">

                                                                <a
                                                                    className="elementor-button elementor-button-link elementor-size-sm elementor-animation-shrink"
                                                                    href={ctaURL}
                                                                    target="_blank"
                                                                >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-icon">
                                          <i
                                              aria-hidden="true"
                                              className="fas"
                                          />{" "}
                                        </span>
                                        <span className="elementor-button-text">
                                          {ctaString}
                                        </span>
                                      </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        Boolean(secondaryCTAString) &&
                                                        <div
                                                            className="elementor-element elementor-element-30942c0e elementor-align-left elementor-widget elementor-widget-button"
                                                            data-id="30942c0e"
                                                            data-element_type="widget"
                                                            data-widget_type="button.default"
                                                        >
                                                            <div className="elementor-widget-container">
                                                                <div
                                                                    className="elementor-button-wrapper text-center md:text-left">

                                                                    <a
                                                                        className="elementor-button elementor-button-link elementor-size-sm elementor-animation-shrink"
                                                                        href="https://app.pabloo.com/sign-up"
                                                                        target="_blank"
                                                                    >
                                      <span className="elementor-button-content-wrapper">
                                        <span className="elementor-button-icon">
                                          <i
                                              aria-hidden="true"
                                              className="fas"
                                          />{" "}
                                        </span>
                                          {secondaryCTAString}
                                      </span>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div
                                                    className="elementor-element elementor-element-2e0d5022 e-con-full e-flex e-con e-child"
                                                    data-id="2e0d5022"
                                                    data-element_type="container"
                                                >
                                                    <div
                                                        className="elementor-element elementor-element-60ddee1b elementor-widget elementor-widget-image"
                                                        data-id="60ddee1b"
                                                        data-element_type="widget"
                                                        data-widget_type="image.default"
                                                    >
                                                        <div className="elementor-widget-container">
                                                            <img
                                                                loading="lazy"
                                                                decoding="async"
                                                                width={376}
                                                                height={426}
                                                                src={imageSource}
                                                                className="lazy attachment-medium_large size-medium_large wp-image-564"
                                                                alt="pabloo-store-credit-cashback"
                                                                title={text}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}